<template lang="pug">
#admin_container.container-small
  h1#container_title 팝업 레이어 입력
  .container_wr
    .local_desc01.local_desc
      p 초기화면 접속 시 자동으로 뜰 팝업레이어를 설정합니다.
    .tbl_frm01.tbl_wrap
      table
        colgroup
          col.grid_4
          col
        tbody.popup-table
          tr
            th(scope="row")
              label 접속기기
            td
              span.frm_info 팝업레이어가 표시될 접속기기를 설정합니다.
              select#nw_device(v-model="args.device")
                option(value='both') PC와 모바일
                option(value='pc') PC
                option(value='mobile') 모바일
          tr
            th(scope="row")
              label 시작일시
            td
              date-picker.popup_date.date_picker(v-model="args.start" type="datetime" value-type="format" placeholder="Select datetime" format="YYYY-MM-DD HH:mm" :show-time-panel="showTimePanel" @close="showTimePanel = false" @pick="dateSelected()" :lang='lang')
                template(v-slot:footer)
                  button.mx-btn.mx-btn-text(@click="showTimePanel = !showTimePanel") {{ showTimePanel ? 'select date' : 'select time' }}

              input#nw_begin_chk.date_check(type='checkbox' v-model="checkbox.start" @change='setDefaultTime()')
              label 시작일시를 오늘로
          tr
            th(scope="row")
              label 종료일시
            td
              date-picker.popup_date.date_picker(v-model="args.end" type="datetime" value-type="format" placeholder="Select datetime" format="YYYY-MM-DD HH:mm" :show-time-panel="showTimePanel" @close="showTimePanel = false" @pick="dateSelected()" :lang='lang')
                template(v-slot:footer)
                  button.mx-btn.mx-btn-text(@click="showTimePanel = !showTimePanel") {{ showTimePanel ? 'select date' : 'select time' }}
              input#nw_end_chk.date_check(type='checkbox' v-model="checkbox.end" @change='setDefaultTime()')
              label 종료일시를 오늘로부터 7일 후로
          tr
            th(scope="row")
              label 팝업 제목
            td
              input.frm_input(type='text' size=80 v-model="args.title")
          tr
            th(scope="row")
              label 팝업 이미지
            td
              input(type='file' multiple @change='onInputImage()' ref='fileUpload')
    .btn_fixed_top
      a.btn.btn_02(@click='$_goTo({name: "popup-admin"})') 목록
      a.btn_submit.btn(@click='addPopup()') 확인
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      checkbox: {
        start: false,
        end: false,
      },
      args: {
        device: 'both',
        never: '',
        start: '',
        end: '',
        title: '',
      },
      popupimg: '',
      showTimePanel: false,
      titleArr: [],
      deviceArr: [],
      lang: {
        days: ['일', '월', '화', '수', '목', '금', '토'],
        months: [
          '1월',
          '2월',
          '3월',
          '4월',
          '5월',
          '6월',
          '7월',
          '8월',
          '9월',
          '10월',
          '11월',
          '12월',
        ],
        yearFormat: 'YYYY년',
        monthFormat: 'MM월',
      },
    };
  },
  computed: {
    ...mapGetters(['popup', 'checkTime']),
    popupNum() {
      let pc = 0;
      let mobile = 0;
      for (var device of this.deviceArr) {
        switch (device) {
          case 'pc':
            pc++;
            break;
          case 'mobile':
            mobile++;
            break;
          case 'both':
            pc++;
            mobile++;
            break;
          default:
        }
      }
      switch (this.args.device) {
        case 'pc':
          pc++;
          break;
        case 'mobile':
          mobile++;
          break;
        case 'both':
          pc++;
          mobile++;
          break;
        default:
      }
      if (pc > 3 || mobile > 3) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    ...mapActions(['savePopup', 'getTime', 'removePopup']),
    async addPopup() {
      if (this.popupNum) {
        alert('해당 접속기기의 팝업 개수가 초과되었습니다.');
        return;
      }
      if (this.args.start == '') {
        alert('시작일시를 등록해주세요.');
        return;
      } else if (this.args.title == '') {
        alert('팝업 제목을 등록해주세요.');
        return;
      } else if (this.args.title.length > 20) {
        alert('팝업 제목의 글자 수가 초과되었습니다.');
        return;
      } else if (this.args.end == '') {
        alert('종료일시를 등록해주세요.');
        return;
      } else if (this.popupimg == '') {
        alert('팝업 이미지를 첨부해주세요.');
        return;
      }

      const formData = new FormData();
      const blob = new Blob([this.popupimg], {
        type: this.popupimg.type,
      });
      formData.append('file', blob, this.popupimg.name);
      formData.append('start', this.args.start);
      formData.append('end', this.args.end);
      formData.append('title', this.args.title);
      formData.append('device', this.args.device);

      await this.$_upLoad('post', 'admin/popupimg', formData).then(res => {
        if (res.status === 200) {
          alert('팝업이 추가되었습니다.');
          this.$_goTo({ name: 'popup-admin' });
        } else if (res.status === 400) {
          alert('첨부된 사진을 확인해주세요.');
          return;
        } else {
          alert('업로드에 실패하였습니다.');
          return;
        }
      });
    },
    setDefaultTime() {
      if (this.checkbox.start) {
        let today = this.$moment().format('YYYY-MM-DD');
        this.args.start = this.$moment(today).format('YYYY-MM-DD HH:mm');
      } else {
        this.args.start = '';
      }
      if (this.checkbox.end) {
        let weekLater = this.$moment().add(7, 'd').format('YYYY-MM-DD');
        this.args.end = this.$moment(weekLater).format('YYYY-MM-DD HH:mm');
      } else {
        this.args.end = '';
      }
    },
    onInputImage() {
      this.popupimg = this.$refs.fileUpload.files[0];
    },
    dateSelected() {
      let today = this.$moment().format('YYYY-MM-DD');
      let startTime = this.$moment(today).format('YYYY-MM-DD HH:mm');
      let weekLater = this.$moment().add(7, 'd').format('YYYY-MM-DD');
      let endTime = this.$moment(weekLater).format('YYYY-MM-DD HH:mm');

      if (this.checkbox.start && this.args.start !== startTime) {
        this.checkbox.start = false;
      } else if (!this.checkbox.start && this.args.start == startTime) {
        this.checkbox.start = true;
      }
      if (this.checkbox.end && this.args.end !== endTime) {
        this.checkbox.start = false;
      } else if (!this.checkbox.end && this.args.end == endTime) {
        this.checkbox.end = true;
      }
    },
    getPopupTitle() {
      this.$_admin_get('admin/popup/title').then(res => {
        let $_res = res.data.res;
        this.titleArr = $_res.title;
        this.deviceArr = $_res.device;
      });
    },
  },
  beforeMount() {},
  mounted() {
    this.getPopupTitle();
  },
  created() {},
};
</script>

<style scoped>
@import '../../../assets/css/admin.css';
@import '../../../assets/css/board.css';
.btn {
  height: 30px;
  border: 0;
  border-radius: 5px;
  padding: 0 10px;
  font-weight: bold;
  font-size: 1.09em;
  vertical-align: middle;
}
.btn_submit {
  margin-left: 5px;
  background: #ff4081;
}
.btn_fixed_top .btn_02:hover {
  color: #fff;
  background: #6a7385;
}
.btn_submit:hover {
  background: #ff4343;
  color: white !important;
}
.date_check {
  margin-left: 10px;
}
.popup-table input[type='checkbox'] {
  width: 12px;
  height: 12px;
}
.popup-table select {
  border: 1px solid #d5d5d5;
}
#nw_disable_hours {
  width: 50px;
}
td label {
  margin-left: 5px;
}

.fa_download {
  margin-right: 5px;
}
.board_btn {
  padding: 20px;
}
.center {
  text-align: center !important;
}
.inner .board_table .board_button a#btn_submit {
  padding: 10px 25px;
  background: #333;
  color: #fff;
  border: 1px solid #ddd;
  line-height: 100%;
  cursor: pointer;
}
.board_list {
  clear: both;
  width: 100%;
  margin: 16px 0;
  border-top: 1px solid #aaa;
  border-bottom: 1px solid #aaa;
  border-top: 2px solid #1f1f1f;
}
.board_list th {
  background: #fafafa;
  font-weight: normal;
  text-align: center;
  border-bottom: 1px solid #e8e8e8;
  height: 46px;
  color: #333;
}
.board_list td.subject {
  text-align: left;
}
.board_list td.subject a {
  margin-left: 20px;
}
.board_list td {
  border-bottom: 1px solid #eee;
  height: 40px;
  text-align: center;
}
table td {
  line-height: 22px;
}
#s41.sub {
  padding: 0;
  padding-top: 30px;
}

.edit_btn {
  margin-top: 50px;
}
.board_button {
  clear: both;
  text-align: right;
  margin-bottom: 10px;
}
.board_button a {
  font-size: 13px;
  display: inline-block;
  padding: 10px 25px;
  border: 1px solid #ddd;
  line-height: 100%;
  margin-left: 5px;
  background: #fff;
}
.board_button a.newb {
  background: #2c2c2c;
  color: #fff;
  cursor: pointer;
}
em img {
  margin-right: 13px;
}
</style>
